import {FormControl, FormHelperText, FormLabel, Switch} from '@chakra-ui/react';

import {useFormContext} from 'react-hook-form';

import {QuestionProps} from './question';

export function BooleanQuestion(props: Readonly<QuestionProps>) {
  const {question} = props;
  const {register} = useFormContext();

  return (
    <FormControl key={question.id} display='flex' alignItems='center'>
      <FormLabel flex={1}>{question.title}</FormLabel>
      <Switch {...register(question.id)} />
      <FormHelperText>{question.description}</FormHelperText>
    </FormControl>
  );
}
